import { createContext, useContext, useEffect } from "react"
import { ReactNode } from "react"
import {
  ChurchCenterIframeState,
  useChurchCenterIframe,
} from "../hooks/useChurchCenterIframe"

const ChurchCenterIframeContext = createContext<ChurchCenterIframeState>({
  inBlessedIframe: false,
  close: () => {},
})

export function ChurchCenterIframeProvider({
  children,
}: {
  children: ReactNode
}) {
  const iframeState = useChurchCenterIframe()

  useEffect(() => {
    const classList = document.body.classList

    classList.remove("iframed")
    classList.remove("iframed--blessed-yes")

    if (iframeState.inBlessedIframe) {
      classList.add("iframed")
      classList.add(`iframed--blessed-yes`)
    }
  }, [iframeState.inBlessedIframe])

  return (
    <ChurchCenterIframeContext.Provider value={iframeState}>
      {children}
    </ChurchCenterIframeContext.Provider>
  )
}

function useChurchCenterIframeContext(): ChurchCenterIframeState {
  const context = useContext(ChurchCenterIframeContext)
  if (context === undefined)
    throw new Error(
      "useChurchCenterIframeContext must be used within a ChurchCenterIframeProvider",
    )

  return context
}

export function ChurchCenterIframeCloseButton() {
  const { inBlessedIframe, close } = useChurchCenterIframeContext()

  if (!inBlessedIframe) return null

  return (
    <button
      className="close-iframe"
      onClick={close}
      style={{ border: "none", background: "none" }}
    >
      <span className="icon d-if ai-c">
        <svg
          className="symbol"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
        >
          <title>x</title>
          <polygon points="16 1.611 14.389 0 8 6.389 1.611 0 0 1.611 6.389 8 0 14.389 1.611 16 8 9.611 14.389 16 16 14.389 9.611 8 16 1.611" />
        </svg>
      </span>
    </button>
  )
}
